import React from 'react'
import {
  lighten,
  styled,
  ToggleButton as MuiToggleButton,
  toggleButtonClasses,
  ToggleButtonProps as MuiToggleButtonProps,
  unstable_composeClasses,
} from '@mui/material'
import classnames from 'classnames'

import ButtonNewest, { ButtonProps as ButtonNewestProps } from '../ButtonNewest/Button'
import { getToggleButtonUtilityClass } from './toggleButtonClasses'

interface ToggleButtonProps
  extends MuiToggleButtonProps<'button', Omit<ButtonNewestProps, keyof MuiToggleButtonProps>> {}

const ToggleButtonRoot = styled(ButtonNewest, {
  name: 'ToggleButton',
  slot: 'Root',
  overridesResolver: (_, styles) => styles.root,
})(({ theme }) => {
  return {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.pxToRem(12),
    [`&.${toggleButtonClasses.selected}`]: {
      color: theme.palette.primary.main,
      backgroundColor: lighten(theme.palette.primary.light, 0.85),
      borderColor: theme.palette.primary.main,
      cursor: 'default',
      '&:hover': {
        backgroundColor: lighten(theme.palette.primary.light, 0.85),
      },
    },
  }
})

const useUtilityClasses = (ownerState: Partial<ToggleButtonProps>) => {
  const slots = {
    root: ['root'],
  }

  return unstable_composeClasses(slots, getToggleButtonUtilityClass, ownerState.classes)
}

const ToggleButton = (props: ToggleButtonProps) => {
  const { className, ...other } = props
  const slotClasses = useUtilityClasses(props)

  return (
    <ToggleButtonRoot
      as={MuiToggleButton}
      className={classnames(slotClasses.root, className)}
      {...(other as ButtonNewestProps<'button', Omit<MuiToggleButtonProps, keyof ButtonNewestProps>>)}
    />
  )
}

export default ToggleButton
